import BreadCrumbs from './BreadCrumbs';
import './BreadCrumbs.scss';

export default BreadCrumbs;